<template>
  <div>
    <toggle-single id="enable-agenda"
                   label-name="Enabled"
                   :toggle-model="hasAgenda"
                   @toggle-click="handleToggleClick"
                   />
    <!--- AGENDA  -->
    <b-form-group>
      <label-info
          id="session-description"
          label-name="Agenda"
          label-info=""
      />
      <transition name="fadeHeight" mode="out-in">
        <Editor
            id="textarea-default"
            style="height:500px"
            v-show="true"
            @input="input"
            :clear="clear"
            :content="agenda"
            content-size="lg"
            @resetClear="resetClear"
        />
      </transition>
    </b-form-group>
    <pre v-if="!production" class="small">{{ context }}</pre>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LabelInfo from "@/components/common/labelInfo";
import ToggleSingle from "@/components/common/toggleSingle";
import Editor from "@/components/common/editor";
export default {
  name: "AddEditSession_Agenda",
  components: {
    LabelInfo,
    ToggleSingle,
    Editor
  },
  props: {
    form: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  beforeMount() {},
  mounted() {},
  computed: {
    ...mapGetters({}),
  },
  methods: {
    handleValueChange(key, value) { //mixin
      this.$emit('value-change', {key:key, value:value});
    },
    handleToggleClick(){
      this.hasAgenda = !this.hasAgenda;
      this.handleValueChange('hasAgenda', this.hasAgenda);
    },
    input(val) {
      this.handleValueChange('agenda', val.content);
    },
    resetClear() {
      this.clear = false;
    },
  },
  data() {
    return {
      production: true,
      clear: false,
      hasAgenda: this.form && this.form.hasAgenda ? this.form.hasAgenda : true,
      agenda: this.form && this.form.agenda ? this.form.agenda : null,
    };
  },
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.session-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#session_calender .btn-outline-info:hover,
#session_calender .btn-outline-info:active,
#session_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>

